import React, { Component } from 'react'
import { FormControl, TextField, Button, IconButton, Icon, Slide, Snackbar, Dialog, Checkbox, FormControlLabel } from '@material-ui/core'
import Http from '../../../../Http';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withRouter } from "react-router-dom";
import './Precios.css';
import { theme } from '../../../../Theme';
import CobroServicios from "./cobroServicios";
import ListaPrecios from '../../../Listaprecios/ListaPrecios';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Precios extends Component {

  state = {
    listas: [],
    listasCliente: [],
    tiposListas: [],
    listaSel: null,
    sbOpen: false,
    sbMsg: '',
    dlpOpen: false,
    dlpId: null,
    changed: false,
    nuevaData: false,
    listaPreciosServicios: {
      lp_nombre: 'SERVICIOS QUE SE COBRAN',
      lp_default: 0,
      lp_cliente: 0,
      especificaciones: []
    }
  }

  async componentDidMount() {

    // await this.loadListas();
    await this.loadClienteListas();
    await this.loadTiposDeLista();
  }

  async componentWillUnmount() {
    const { changed, listaPreciosServicios } = this.state;
    if (!changed) {
      await Http.post(`lista-precio/save`, { listaPrecios: listaPreciosServicios, especificacionesRemovidas: [] });
    }
  }

  loadListas = async (q = null) => {
    try {
      // console.log(`listas-precffios/${q ? `?q=${q}` : ''}`)
      var Res = await Http.get(`lista-precio/get${q ? `?q=${q}` : ''}`);
      if (!Res.error) {
        this.setState({ listas: Res.data.listas })
      }
    } catch (error) {
      console.log(error)
    }
  }

  loadClienteListas = async () => {
    try {
      var Res = await Http.get(`lista-precio/cliente/${this.props.match.params.id}`);
      if (!Res.error) {
        // la lista de precios con prioridad -1, es y debe de ser la de cobro de servicios
        let listaPreciosServicios = Res.data.find(lp => lp.prioridad === -1);
        if (!listaPreciosServicios) {
          listaPreciosServicios = {
            lp_nombre: 'SERVICIOS QUE SE COBRAN',
            lp_default: 0,
            lp_cliente: 0,
            especificaciones: [
              {
                id_lista_precio_tipo: 10,
                id_valor_aplicado: 1,
                valor_aplicado: 0,
                condiciones: [],
              }
            ]
          }
        } else {
          listaPreciosServicios = (await Http.get(`lista-precio/one/${listaPreciosServicios.id_lista_precios}`)).data
        }
        // el filter es para que solo muestre las listas de precio que son necesarias
        this.setState({ listasCliente: Res.data.filter(data => data.prioridad > 0), listaPreciosServicios: listaPreciosServicios })
      }
      // console.log(Res)
    } catch (error) {

    }
  }

  loadTiposDeLista = async () => {
    try {
      var Res = await Http.get(`lista-precio-tipo/all`);
      if (!Res.error) {
        this.setState({ tiposListas: Res.data })
      }
      // console.log(Res)
    } catch (error) {

    }
  }

  addLista = async (listaSel, prioridad) => {
    if (!listaSel) return;
    try {
      const Res = await Http.post(`cliente-precio/save/`, { id_lista_precios: listaSel.id, id_cliente: this.props.match.params.id, prioridad });
      if (!Res.error) {
        // this.setState({ listasCliente: Res.data })
        this.loadClienteListas();
      }
      else {
        this.setState({ sbMsg: Res.errMsg, sbOpen: true })
      }
    } catch (error) {

    }
  }

  removeLista = async (lista) => {
    try {
      var Res = await Http.post(`cliente-precio/delete/`, { ...lista });
      if (!Res.error) {
        // this.setState({ listasCliente: Res.data })
        this.loadClienteListas();
      }
    } catch (error) {
      console.error(error)
    }
  }

  createLista = () => {
    this.setState({ dlpId: null, dlpOpen: true, nuevaData: true })

  }

  editLista = (id) => {
    // this.props.history.push(`/ListaPreciosEdit/${lista.id_lista_precios}`)
    this.setState({ dlpId: id, dlpOpen: true })
  }

  closeLista = async (data) => {
    this.setState({ dlpOpen: false, dlpId: null });
    if (data && data.id) {
      await this.addLista({ id: data.id })
    }
    await this.loadListas();
  }

  listaUp = async (lista) => {
    try {
      var Res = await Http.post(`cliente-precio/up`, { ...lista });
      if (!Res.error) {
        this.loadClienteListas();
      }
    } catch (error) {
      console.log(error)
    }
  }

  listaDown = async (lista) => {
    try {
      var Res = await Http.post(`cliente-precio/down`, { ...lista });
      if (!Res.error) {
        this.loadClienteListas();
      }
    } catch (error) {
      console.log(error)
    }
  }

  handleOnCobroServicios = async (listaPreciosServicios, especificacionesRemovidas) => {
    try {
      const Res = await Http.post(`lista-precio/save`, { listaPrecios: listaPreciosServicios, especificacionesRemovidas });
      if (!Res.error) {

        if (!listaPreciosServicios.id) {
          // crea la lista de precios para el cobro de servicios
          await this.addLista(Res.data, -1);
        }

        listaPreciosServicios = { ...Res.data, especificaciones: Res.data.especs };
        this.setState({ listaPreciosServicios, changed: true });
      }
    } catch (error) {
      console.log(error);
    }
  }

  pagoTransportistaChange = async (event, lista) => {
    try {
      let res = await Http.post(`lista-precio/save-simple`, {
        id: lista.id_lista_precios,
        pago_transportista: event.target.checked
      });
      if(!res.error) {
        this.loadClienteListas()
      }
    } catch (error) {
      console.log(error)
    }
  }

  onAutocompleteChange = async (value, text) => {
    if (text) {
      this.setState({ listaSearch: value });
      await this.loadListas(value);
    } else {
      this.setState({ listaSel: value });
    }
  }

  render() {
    const { listas, listasCliente, sbMsg, sbOpen, dlpOpen, dlpId, tiposListas, listaPreciosServicios, listaSel, nuevaData = false } = this.state;
    return (
      <div style={{ display: 'flex', flexFlow: 'row nowrap' }} >
        <div>
          {
            (tiposListas.length > 0) && (
              <CobroServicios
                title={'Servicios Que Se Cobran'}
                tiposListas={tiposListas}
                listaPreciosServicios={listaPreciosServicios}
                handleOnCobroServicios={this.handleOnCobroServicios} />
            )
          }
        </div>
        <div style={{ width: '70%', marginLeft: 'auto', marginRight: 'auto', padding: 15 }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <FormControl variant="outlined">
              <Autocomplete
                id="combo-box-demo"
                options={listas}
                getOptionLabel={option => option.lp_nombre}
                style={{ width: 200 }}
                onChange={(e, val) => { this.onAutocompleteChange(val, false) }}
                renderInput={params => (
                  <TextField 
                    {...params} 
                    label="Listas de precios" 
                    variant="outlined" 
                    fullWidth 
                    onChange={(e) => { this.onAutocompleteChange(e.target.value, true) }}
                  />
                )}
              />
            </FormControl>
            <Button onClick={() => this.addLista(listaSel)} style={{ marginRight: 10, marginLeft: 14 }}>
              Agregar a listas
            </Button>
            <Button variant='outlined' onClick={this.createLista} style={{ marginRight: 10, marginLeft: 14 }}>
              Crear nueva
            </Button>
          </div>

          <div>
            {listasCliente.map((lista, i) => (
              <div className='listaCliente' style={{ backgroundColor: theme.palette.primary.main }} key={i}>
                <span style={{ marginTop: 10 }}>{lista.lp_nombre}</span>
                <div style={{ flexDirection: 'row' }}>
                  <IconButton onClick={() => { this.removeLista(lista) }}>
                    <Icon color='secondary'>remove_circle</Icon>
                  </IconButton>
                  <IconButton onClick={() => { this.editLista(lista.id_lista_precios) }}>
                    <Icon color='secondary'>remove_red_eye</Icon>
                  </IconButton>
                  <IconButton onClick={() => { this.listaUp(lista) }}>
                    <Icon color='secondary'>arrow_drop_up</Icon>
                  </IconButton>
                  <IconButton onClick={() => { this.listaDown(lista) }}>
                    <Icon color='secondary'>arrow_drop_down</Icon>
                  </IconButton>
                </div>
                <FormControlLabel
                  control={<Checkbox checked={lista.pago_transportista === 1} onChange={(e) => this.pagoTransportistaChange(e, lista)} />}
                  label={'P. transportista'}
                />
              </div>
            ))}
          </div>

          <div>
            <Snackbar
              open={sbOpen}
              onClose={() => { this.setState({ sbOpen: false }) }}
              TransitionComponent={Slide}
              ContentProps={{
                'aria-describedby': 'message-id',
              }}
              message={<span id="message-id">{sbMsg}</span>}
            />
          </div>

          <div>
            <Dialog fullScreen open={dlpOpen} onClose={() => this.closeLista()} TransitionComponent={Transition}>
              <div style={{ position: 'absolute', right: 0 }}>
                <IconButton onClick={() => this.closeLista()}>
                  <Icon>close</Icon>
                </IconButton>
              </div>
              <ListaPrecios id={dlpId} onSave={(data) => { this.closeLista(data) }} scrollInnerContent nuevaData={nuevaData} ></ListaPrecios>
            </Dialog>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Precios)